const APP_CONFIG = {
  version: "7.90.0",
  title: "Claire V7.90.0",
  version_client: "7.90.0",
};

export default APP_CONFIG;
